<template>
  <div class="v-legend-item"
       :style="[styles]"
       :class="[classes]"
  >
    <button class="btn v-legend-item--inner text-xs fw-medium px-8 py-4"
            @click="$emit('click')">
      <slot/>
    </button>
  </div>
</template>

<script>

import VMeasurable from "../../mixins/measurable";

export default {
  name: 'VLegendItem',
  mixins: [VMeasurable],
  emits: ['click'],
  props: {
    top: {
      type: String,
      default: '0',
    },
    active: Boolean,
  },
  computed: {
    styles() {
      return {
        ...this.measurableStyles,
        'top': !!this.top ? this.top + '%' : '0',
      }
    },
    classes() {
      return {
        'v-legend-active': !!this.active,
      }
    }
  }
};
</script>
